var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7368 1.06383C12.5204 -0.354611 14.4796 -0.354609 15.2632 1.06383L26.7242 21.8085C27.5078 23.227 26.5283 25 24.961 25H2.03903C0.471721 25 -0.507846 23.2269 0.27581 21.8085L11.7368 1.06383Z",
    fill: "#F1D24D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0832 9.49769C12.038 8.68433 12.6854 8 13.5 8C14.3146 8 14.962 8.68433 14.9168 9.49769L14.5555 16.0015C14.5243 16.5617 14.061 17 13.5 17C12.939 17 12.4757 16.5617 12.4445 16.0015L12.0832 9.49769Z",
    fill: "#303030"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 20,
    r: 1,
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkIcon);
export default __webpack_public_path__ + "static/media/exclamation-mark-icon.43cc3c3af38c9d2bd256c2744fc264d2.svg";
export { ForwardRef as ReactComponent };